// extracted by mini-css-extract-plugin
module.exports = {"dl":"DefList_dl__164m-","item":"DefList_item__2dplE","inline":"DefList_inline__fY3Sv","hasIcon":"DefList_hasIcon__-SIOZ","prepend":"DefList_prepend__rUaGw"};